import classNames from "classnames";

/**
 * Bars icon component with fancy animation.
 */
export const BarsIcon = ({ isOpen, onClick }: { isOpen: boolean; onClick: () => void }) => {
  const className = classNames("bars-icon", { open: isOpen });

  return (
    <div className="bars-icon-wrapper" onClick={onClick}>
      <div className={className}>
        <span />
        <span />
        <span />
      </div>
    </div>
  );
};
